import React, { Component } from 'react';
import $ from 'jquery';

class Footer extends Component {
	
	
	componentDidMount()
	{
		$(document).on("click", ".btnAlertaAceptar", function(e)
		{
			e.preventDefault();
			$(".c_divAlertaCapa").fadeOut();
		});
		
		$(document).on("click", ".btnAlertaCancelar", function(e)
		{
			e.preventDefault();
			$(".c_divAlertaCapa").fadeOut();
		});
		
		$(document).on("click", ".aEliminarMenu", function(e)
		{
			e.preventDefault();
			$(this).next().fadeIn();
		});
		
		$(document).on("click", ".aEliminarMenu2", function(e)
		{
			e.preventDefault();
			$(this).next().fadeIn();
		});
	}
	
	render() {
	  return (
		<div>
			<div className="divContenedorPie_Panel">
				 PROMPERU 2024
				<a href="#" className="btnTop_Panel" />
			</div>
		</div>
	  );
	}
}
 
export default Footer;
